import React, { useMemo, useEffect } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import parse from "html-react-parser";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useLocation } from "react-router-dom";
import { useUser } from "contexts/userContext/userContext.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";
import config from "config.ts";

import "./Announcement.scss";

const Announcement = () => {
  const {
    getAnnouncement,
    closeAnnouncement,
    getDirection,
    getLanguage,
    fetchAnnouncement,
  } = useContent();
  const { getUserData } = useUser();
  const userId = getUserData()?.UserId;
  const location = useLocation();
  const { setCookies } = useCookie();

  const currentPage = useMemo(
    () =>
      location.pathname.includes("/user/")
        ? location.pathname.split("/user/")[1].split("/")[1]
        : location.pathname.includes(`/${getLanguage()}/`) &&
          location.pathname.split(`/${getLanguage()}/`)[1].split("/")[0],
    []
  );

  const announcement = getAnnouncement();
  const nameToSave = `Announcement-${announcement?.CookieName}`;
  const displayType = announcement?.DisplayType;
  const isPopup = displayType === "Popup";

  useEffect(() => {
    fetchAnnouncement(currentPage, userId);
  }, [currentPage, userId]);

  const getIconNameUrl = () => {
    const type = announcement?.Type.toLowerCase();
    return `${config.api.resource}/assets/images/announcements/${type}-announcement.svg`;
  };

  const getIconImage = () => {
    const icon = getIconNameUrl();
    if (icon) {
      return <Image src={icon} alt="icon" title="" />;
    }
    return null;
  };

  const closePopup = () => {
    //save cookie for 1 hour
    const today = new Date();
    const todayPlus1Hour = new Date(today);
    todayPlus1Hour.setHours(todayPlus1Hour.getHours() + 1);
    setCookies(nameToSave, true, {
      path: "/",
      domain: ".jumbomail.me",
      expires: new Date(todayPlus1Hour),
    });

    closeAnnouncement();
  };

  useEffect(() => {
    // cos of position fixed of header need to change some styles
    if (announcement && !isPopup) {
      const elem = document.querySelector(".page-content");
      elem.classList.add("black-friday-header-exist");

      // elem next to header is content of the page, need to change its margin top to fit the promo header
      const contentElem = document.querySelector("nav")?.nextElementSibling;

      if (!contentElem) return;

      const contentElemMargin = window.getComputedStyle(contentElem).marginTop;

      if (contentElemMargin === "0px") {
        contentElem.style.marginTop = "90px";
      }
      if (contentElemMargin === "-90px") {
        contentElem.style.marginTop = "0px";
      }

      return () => {
        elem.classList.remove("black-friday-header-exist");
        if (window.location.href.includes("gallery")) {
          contentElem.style.marginTop = "-90px";
        } else {
          contentElem.style.marginTop = contentElemMargin;
        }
      };
    }
  }, [announcement, isPopup]);

  return announcement ? (
    isPopup ? (
      <div className={`announcement-popup ${getDirection()}`}>
        <div className={`announcement-popup-container`}>
          <div
            className={`announcement-side-border color-${announcement?.Type.toLowerCase()} ${
              getDirection() === "rtl" ? "right" : "left"
            }`}
          ></div>
          <div className="announcement-popup-header">
            <div className="announcement-popup-close" onClick={closePopup}>
              <Icon name="x" />
            </div>
          </div>
          <div className="announcement-popup-body">
            <div
              className={`announcement-popup-icon icon-${announcement?.Type.toLowerCase()}`}
            >
              {getIconImage()}
            </div>
            <div className="announcement-popup-title">
              <h3> {announcement?.Title}</h3>
            </div>
            <div className="announcement-popup-content">
              {parse(announcement?.Content)}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div
        className={`announcement-top-panel ${getDirection()} color-${announcement?.Type.toLowerCase()}`}
      >
        <div className="announcement-top-panel-container">
          <div
            className={`announcement-side-border color-${announcement?.Type.toLowerCase()} ${
              getDirection() === "rtl" ? "right" : "left"
            }`}
          ></div>

          <div className="announcement-top-panel-container-div">
            <div className="announcement-top-panel-content">
              <div
                className={`announcement-top-panel-icon icon-${announcement?.Type.toLowerCase()}`}
              >
                {getIconImage()}
              </div>
              <div className="announcement-top-panel-body">
                <div className="announcement-top-panel-title">
                  <h3> {announcement?.Title}</h3>
                </div>
                <div className="announcement-top-panel-text">
                  {parse(announcement?.Content)}
                </div>
              </div>
            </div>
            <div className="announcement-top-panel-header">
              <div
                className="announcement-top-panel-close"
                onClick={closePopup}
              >
                <Icon name="x" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  ) : null;
};

export default Announcement;
